import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Button from 'components/field/Button';
import Typography from 'components/global/Typography';

import useLocalStorage from 'hooks/useLocalStorage';
import useSwitchSupportClient from 'hooks/useSwitchSupportClient';

import { faArrowsRotate, faRightFromBracket } from '@fortawesome/pro-solid-svg-icons';

import * as S from '../AppLayout/AppLayout.styled';

const GlobalAlert = () => {
	const user = useSelector((state) => state.user);
	const [supportAccessUntil] = useLocalStorage('supportAccessUntil', null);
	const { t } = useTranslation();
	const switchSupportClient = useSwitchSupportClient();

	useEffect(() => {
		if (!supportAccessUntil || supportAccessUntil - Date.now() < 0) return;
		const timeOut = setInterval(() => {
			if (supportAccessUntil && supportAccessUntil - Date.now() < 0) {
				switchSupportClient();
			}
		}, 1000);
		return () => clearInterval(timeOut);
	}, []);

	return (
		user?.isSupportUser &&
		supportAccessUntil &&
		supportAccessUntil - Date.now() > 0 && (
			<S.AlertContainer
				variant="success"
				content={<Trans i18nKey="support.successfulConnectionTo" values={{ email: user.email }} />}
				showIcon>
				<S.AlertFlexDiv>
					<Typography fontWeight="500" color="var(--alert-description)">
						{Math.round((supportAccessUntil - Date.now()) / 60000)} {t('minutes')}
					</Typography>
					<S.BlackIcon color="var(--alert-description)" icon={faArrowsRotate} />
					<Button
						icon={faRightFromBracket}
						label="logout"
						size="x-small"
						onClick={() => switchSupportClient()}
						iconPos="right"
						variant="borderless"
					/>
				</S.AlertFlexDiv>
			</S.AlertContainer>
		)
	);
};
export default GlobalAlert;
